var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-box"},[_c('video',{ref:"videoPlayer",staticStyle:{"max-height":"450px"},attrs:{"poster":_vm.vimage,"controls":_vm.settingControl,"autoplay":"","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }